(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('SessionStorage', SessionStorage);

    function SessionStorage() {

        var service = {
            get: getFromSession,
            save: putToSession,
            init: initFromSession,
            saveAll: saveAllToSession
        };

        return service;
        
        function initFromSession(obj, prefix, keys) {
        	angular.forEach(keys, function(key, index) {
        		var item = getFromSession(prefix + '.' + key);
        		this[key] = item;
    		}, obj);
        	
        }

        function saveAllToSession(obj, prefix, keys) {
        	angular.forEach(keys, function(key, index) {
        		putToSession(prefix + '.' + key, this[key]);
    		}, obj);
        }

        function getFromSession(key) {
        	if (sessionStorage) {
        		var item = sessionStorage.getItem(key);
        		if (item) {
        			item = JSON.parse(item);
        		}
        		return item;
        	}
        	return null;
        }

        function putToSession(key, val) {
        	if (sessionStorage) {
        		sessionStorage.setItem(key, JSON.stringify(val));
        	}
        	return null;
        }

    }

})();
